import { VehicleQuestionModel } from './vehicle-question.model';

export class VehicleDataModel {

  firstRegistrationDate?: Date;
  questions?: VehicleQuestionModel[];
  vehicleCodeEurotax?: string;
  vehicleCodeInfoekspert?: string;
  vehicleCodeInfoExpertLink4?: string;
  registrationNumber: string;
  productionYear?: number;
  fuelTypeCode?: string;
  numberOfDoors?: number;
  brandCode?: number | string;
  modelCode?: number | string;
  engineCapacity?: string;
  brandName?: string;
  modelName?: string;
  vin?: string;

  constructor() {
    this.questions = [];
  }
}
